import React from 'react';
import ReactDOM from 'react-dom';
import Keycloak from 'keycloak-js';

import { App } from './App';

import './index.css';
import 'react-datepicker/dist/react-datepicker.css';

const KEYCLOAK_CONFIG_PATH = `${process.env.PUBLIC_URL}/${process.env.REACT_APP_KEYCLOAK_JSON_PATH}`;

let keycloakInstance = null;

const getKeycloakInstance = () => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak(KEYCLOAK_CONFIG_PATH);
  }
  return keycloakInstance;
};

const keycloak = getKeycloakInstance();

keycloak
  .init({
    onLoad: 'login-required',
    checkLoginIframe: false,
    pkceMethod: 'S256',
    responseMode: 'query',
    flow: 'standard',
  })
  .then((authenticated) => {
    if (authenticated) {
      ReactDOM.render(
        <React.StrictMode>
          <App keycloak={keycloak} />
        </React.StrictMode>,
        document.getElementById('root')
      );
    }
  });
